/* Henri Store - nota da loja (Konfidency) em produtos sem avaliacao propria.
   Rotulado "avaliacoes da loja". Nao altera o schema do produto. v3 */
(function () {
  if (location.pathname.indexOf('/products/') === -1) return;
  var API = 'https://reviews-api.konfidency.com.br/henristore/';
  var CSS = '.hs-store-rating{display:inline-flex;align-items:center;gap:14px;margin:4px 0 10px;cursor:pointer;font-family:inherit;line-height:1;background:none;border:0;padding:0;text-align:left}' +
    '.hs-sr-num,.hs-sr-count{font-size:18px;font-weight:500;color:#111;border-bottom:1px solid #111;padding-bottom:3px}' +
    '.hs-sr-stars{color:#f5b301;font-size:16px;letter-spacing:1px;margin-left:6px}' +
    '.hs-sr-sep{width:1px;height:22px;background:#ddd}' +
    '.hs-sr-label{font-size:15px;color:#666;margin-left:6px}';
  function getJSON(u) { return fetch(u).then(function (r) { return r.json(); }); }
  function findSlot() {
    return document.querySelector('.productView-moreItem .konfidency-reviews-summary[data-sku]') ||
           document.querySelector('.konfidency-reviews-summary[data-sku]');
  }
  function build(nota, total) {
    var el = document.createElement('button');
    el.type = 'button';
    el.className = 'hs-store-rating';
    el.setAttribute('aria-label', 'Nota da loja ' + nota + ' de 5, ' + total + ' avaliacoes da loja');
    el.innerHTML = '<span class="hs-sr-num">' + nota + '</span><span class="hs-sr-stars" aria-hidden="true">★★★★★</span>' +
      '<span class="hs-sr-sep"></span>' +
      '<span class="hs-sr-count">' + total.toLocaleString('pt-BR') + '</span><span class="hs-sr-label">avaliações da loja</span>';
    el.addEventListener('click', function () {
      var t = document.querySelector('.konfidency-storeReviewCarousel') || document.querySelector('.konfidency-store-review');
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    return el;
  }
  function init() {
    // o bloco da Konfidency e criado via JS depois do carregamento: espera ate 15s
    var n = 0;
    (function waitSlot() {
      var slot = findSlot();
      if (slot) return run(slot);
      if (++n < 50) setTimeout(waitSlot, 300);
    })();
  }
  function run(slot) {
    var sku = slot.getAttribute('data-sku');
    Promise.all([getJSON(API + sku + '/summary'), getJSON(API + 'store-reviews/summary')]).then(function (res) {
      var p = res[0] || {}, s = (res[1] || [])[0];
      var count = (Array.isArray(p.reviews) && p.reviews[0]) ? (p.reviews[0].reviewCount || 0) : 0;
      if (count > 0 || !s || !s.count) return;
      var nota = (Math.round(s.avgRating * 10) / 10).toFixed(1).replace('.', ',');
      var st = document.createElement('style');
      st.textContent = CSS + '.konfidency-reviews-summary[data-sku="' + sku + '"]{display:none!important}';
      document.head.appendChild(st);
      // o widget da Konfidency re-renderiza depois do carregamento; garante o selo por 15s
      var tries = 0;
      function ensure() {
        var sl = findSlot();
        if (sl && !document.querySelector('.hs-store-rating')) sl.parentNode.insertBefore(build(nota, s.count), sl.nextSibling);
        if (++tries < 30) setTimeout(ensure, 500);
      }
      ensure();
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
